/* ==========================================================================
   Back In Stock trigger placement
   --------------------------------------------------------------------------
   WHY THIS IS JS AND NOT LIQUID:
   #BIS_trigger does not exist in the server-rendered HTML. Verified against
   402KB of product-page source: zero occurrences. The Back In Stock app
   creates the button client-side and appends it high up inside
   <product-content>, above the size picker, which reads backwards -
   "Out of stock -> GET NOTIFIED -> now choose your size".

   There is no template to reorder, so the node is relocated after the app
   creates it. CSS `order` was tried first and rejected: making
   <product-content> a flex container reorders every sibling and pushed the
   button ~500px down the page.

   WHAT IT DOES:
   - Moves #BIS_trigger to sit immediately before section#xpurchase, i.e. the
     slot the Add to cart button normally occupies.
   - While the button is showing, hides the .cartButton in that section. On a
     sold-out variant it is disabled and still reads "Select size", so it is
     dead UI sitting under a live call to action. Only that one button is
     hidden - never the form, the error region or the payment buttons.
   - Restores the Add to cart button the moment an in-stock variant is chosen.
   - Muzzles the app's own wishlist button (see MUZZLE below).

   Re-runs on AJAX variant swaps via MutationObserver, because the theme
   changes variants without a page reload.

   NOTE ON SCHEDULING: this used requestAnimationFrame to coalesce mutations.
   rAF does not fire in a background tab, so a product page opened in a
   background tab kept the button in the wrong place until the tab was
   focused. setTimeout always fires, so it is used instead.

   COORDINATION WITH THE WISHLIST (assets/dico-wishlist.js):
   The wishlist puts its heart beside whichever button is the live call to
   action, by wrapping that button in a .dico-wl-row. On a sold-out variant
   that button is this one, so #BIS_trigger can legitimately have the row as
   its parent rather than <product-content>.

   Everything below therefore positions the ROW when one is present, and the
   button itself when it is not. Without that, the parent check a few lines
   down would see the wrapper, decide the button was somewhere unexpected, and
   bail out - which would leave the Add to cart button hidden after the
   customer picked an in-stock size. The two scripts own different things: this
   one decides WHERE the slot goes, the wishlist decides WHAT is in it.
   ========================================================================== */

(function () {
    'use strict';

    if (document.body.getAttribute('coretex-page') !== 'product') return;

    var pending = null;

    /* MUZZLE: the app's own wishlist button.

       Back In Stock injects its own save button, and it saves the variant that
       was current when the page loaded rather than the size the customer has
       actually picked - the bug that made us build the heart in the theme
       instead. Our stylesheet hides it, but a stylesheet that fails to load (a
       CDN hiccup, a blocked request, a merchant editing settings.css) would
       leave a live button on the page quietly saving the wrong size.

       So it is disabled in the DOM too, where no stylesheet is involved:
       disabled refuses the click, inline display:none hides it without CSS,
       and aria-hidden plus tabindex take it out of the keyboard and screen
       reader order. Idempotent, so it costs nothing to re-run every pass. */
    var MUZZLED = ['#amp-wishlist-save', '#amp-wishlist-button'];

    function muzzle() {
        for (var i = 0; i < MUZZLED.length; i++) {
            var nodes = document.querySelectorAll(MUZZLED[i]);
            for (var j = 0; j < nodes.length; j++) {
                var el = nodes[j];
                if (el.getAttribute('data-dico-muzzled') === 'yes') continue;
                el.setAttribute('data-dico-muzzled', 'yes');
                el.setAttribute('aria-hidden', 'true');
                el.setAttribute('tabindex', '-1');
                el.style.display = 'none';
                el.style.pointerEvents = 'none';
                try { el.disabled = true; } catch (e) {}
            }
        }
    }

    function sync() {
        pending = null;
        muzzle();

        var btn = document.getElementById('BIS_trigger');
        var purchase = document.getElementById('xpurchase');
        if (!btn || !purchase || !purchase.parentElement) return;

        // The wishlist may have wrapped the button; move the wrapper, not the
        // button, or it would be torn out of the row on every pass.
        var slot = btn.closest('.dico-wl-row') || btn;
        if (slot.parentElement !== purchase.parentElement) return;

        // The app toggles the button by display, so measure rather than assume.
        var showing = btn.offsetParent !== null && btn.getBoundingClientRect().height > 0;
        var addToCart = purchase.querySelector('.cartButton');

        if (showing) {
            if (slot.nextElementSibling !== purchase) {
                purchase.parentElement.insertBefore(slot, purchase);
            }
            if (addToCart && addToCart.style.display !== 'none') {
                addToCart.style.display = 'none';
            }
        } else if (addToCart && addToCart.style.display === 'none') {
            addToCart.style.display = '';
        }
    }

    // Coalesce bursts of mutations into one pass. sync() only writes when a
    // value actually differs, so observing our own writes converges.
    function schedule() {
        if (pending === null) pending = setTimeout(sync, 0);
    }

    function start() {
        var host = document.querySelector('.bullet-product-content product-content') || document.body;

        new MutationObserver(schedule).observe(host, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
        });

        document.addEventListener('change', function (e) {
            if (e.target && e.target.closest && e.target.closest('variant-selects')) schedule();
        }, true);

        // The app may create the button after this script runs and without
        // mutating anything the observer is watching, so poll briefly on load.
        // The muzzle rides along: the app's wishlist button is injected late
        // too, and may land outside the observed host.
        var tries = 0;
        var poll = setInterval(function () {
            schedule();
            if (++tries > 20) clearInterval(poll);
        }, 250);

        schedule();
    }

    muzzle();

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();
